import React from 'react';

import './index.css';

const Section = ({ className, title, children }) => (
  <section className={className !== undefined ? className : ''}>
    <div>
      {title !== undefined ? <div className="section-title">{title}</div> : ''}
      {children !== undefined ? children : ''}
    </div>
  </section>
);

export default Section;
